/* eslint-disable react/prop-types */
function ProfileOneIcon({ className = "", width = "24px", height = "24px", fill = "#000000" }) {
  return (
    <svg
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 29.91 29.91"
    >
      <g>
        <circle cx="14.96" cy="14.96" r="14.46" fill="none" stroke={fill} strokeMiterlimit="10" />
        <path fill={fill} d="M5.98,23.12c0,.45,.37,.82,.82,.82s.82-.37,.82-.82c0-2.88,1.66-5.43,4.24-6.64,.89,.58,1.96,.92,3.1,.92s2.22-.34,3.11-.93c.77,.36,1.49,.85,2.08,1.45,1.39,1.39,2.15,3.23,2.15,5.19,0,.45,.37,.82,.82,.82s.82-.37,.82-.82c0-2.4-.93-4.65-2.63-6.35-.57-.57-1.23-1.05-1.93-1.46,.81-.99,1.3-2.25,1.3-3.62,0-3.15-2.56-5.71-5.71-5.71s-5.71,2.56-5.71,5.71c0,1.37,.49,2.63,1.29,3.62-2.8,1.58-4.56,4.52-4.56,7.81ZM14.96,7.61c2.25,0,4.08,1.83,4.08,4.08s-1.83,4.08-4.08,4.08-4.08-1.83-4.08-4.08,1.83-4.08,4.08-4.08Z"/>
      </g>
    </svg>
  );
}

export default ProfileOneIcon;
